type StickyActionBarProps = {
  children: React.ReactNode;
};

export function StickyActionBar({ children }: StickyActionBarProps) {
  return (
    <div className="staff-sticky-bar">
      <div className="staff-sticky-bar__inner">{children}</div>
    </div>
  );
}
